/* ============================================================================
   mm-video-onglets.js — section "vidéos + onglets"
   ----------------------------------------------------------------------------
   Chargé (defer) par sections/MM-Video-Onglets.liquid uniquement.
   Deux responsabilités :
   1. initialiser le slider Splide des vidéos (.mm-splide-video-onglets) ;
   2. gérer les onglets : un clic sur un titre (.mm-vo-onglets-title,
      data-index) active le contenu .mm-vo-content-{index} correspondant.
   Limitation : document.querySelector → seule la PREMIÈRE instance de la
   section sur une page est câblée (une 2e section serait inerte).
   ========================================================================== */

// Init du slider vidéos : 2 slides visibles desktop, 1 sur mobile avec la
// suivante qui dépasse (padding right) pour inciter au swipe.
document.addEventListener("DOMContentLoaded", function () {
	let id = ".mm-splide-video-onglets";
	let splideElem = document.querySelector(id);

  if (splideElem) {
    new Splide(splideElem, {
		type: "slide",
		arrows: true,
		pagination: false,
		gap: 10,
		perPage: 2,
		padding: {
			right: "15rem",
		},
		breakpoints: {
			768: {
				perPage: 1,
				padding: {
					right: '25vw',
				},
			},
		},
	}).mount();
  }
});

// Câblage des onglets, exécuté au parse (script defer : le DOM est prêt).
// Suppose qu'un titre porte déjà .active au rendu initial : si aucun,
// ongletActiveOld est null et le clic lèverait une TypeError.
const sectionContent = document.querySelector('.mm-vo-content-container')
if (sectionContent) {
  const ongletsTitleAll = sectionContent.querySelectorAll(".mm-vo-onglets-title");
  const ongletsContentAll = sectionContent.querySelectorAll('.mm-vo-content');

  if (ongletsTitleAll) {
    ongletsTitleAll.forEach(ongletTitle => {
      ongletTitle.addEventListener('click', function () {
        const indexOnglet = ongletTitle.dataset.index;
        const contentActive = `mm-vo-content-${indexOnglet}`
        ongletsContentAll.forEach(ongletContent => {
          if (ongletContent.classList.contains(contentActive)) {
            ongletContent.classList.add('active');
          } else {
            ongletContent.classList.remove('active');
          }
        });

        const ongletActiveOld = sectionContent.querySelector(".mm-vo-onglets-title.active");
        if (ongletActiveOld != ongletTitle) {
          ongletActiveOld.classList.remove('active')
          ongletTitle.classList.add('active')
        }
      });
    });
  }
}
